import type { SupplierStatus } from '@tandemone/types'
import { BadgeCheck } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

/** the public directory only renders verified (active) and not-verified
 * (onboarding). other statuses get filtered out server-side, but we still
 * accept the wider union so the badge stays typed against the canonical
 * status enum.
 *
 * size 'sm' (default) keeps the compact table/list look, 'lg' is the
 * profile-hero treatment, bigger text and a BadgeCheck seal.
 */
export function SupplierVerifiedBadge({
  status,
  size = 'sm'
}: {
  status: SupplierStatus
  size?: 'sm' | 'lg'
}) {
  const large = size === 'lg'

  if (status === 'active') {
    return (
      <Badge
        className={cn(
          'border-transparent bg-emerald-700 text-emerald-50',
          large && 'h-6 gap-1 px-2.5 text-xs [&>svg]:size-3.5!'
        )}
      >
        {large ? <BadgeCheck /> : null}
        Verified
      </Badge>
    )
  }
  return (
    <Badge
      variant='outline'
      className={cn('text-muted-foreground', large && 'h-6 px-2.5 text-xs')}
    >
      Not Verified
    </Badge>
  )
}
